import React, { Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';
import Loading from '~/components/Loading';
import { isAuthenticated } from '~/services/auth';

const PrivateRoutes = lazy(() => import('./private'));
const PublicRoutes = lazy(() => import('./public'));

const Routes = () => {
  const isAuth = isAuthenticated();
  return (
    <Suspense fallback={<Loading />}>
      {isAuth ? <PrivateRoutes /> : <PublicRoutes />}
    </Suspense>
  );
};

export default withRouter(Routes);
